/* eslint-disable max-len */
/**
 * @file 首页路由
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';

import { isOa } from '@/utils';

import Home from '@/pages/agency/home';

export default [
  {
    label: '概览',
    key: 'home',
    desc: '查看今日、昨日总消耗和有消耗账户数；查看昨日消耗TOP客户、账户和行业；可视化的服务商数据展示',
    href: '/home',
    component: Home,
    perm: (loginStatus: Record<string, any>) => {
      return !isOa();
    },
    behavior: {
      drag_card: '拖动卡片',
    },
    data: [],
  },
];
